<h1>Konto aktivieren</h1>

<mat-vertical-stepper linear="true" #stepper (selectionChange)="selectionChange($event)">
  <mat-step [stepControl]="fgActivationCode" [editable]="!loading && !finished" [completed]="prefilledActivationKey || fgActivationCode.valid">
    <p>Geben Sie hier den Aktivierungscode ein, den Sie per Post oder E-Mail erhalten haben.</p>
    <form [formGroup]="fgActivationCode">
      <ng-template matStepLabel>Aktivierungscode eingeben</ng-template>
      <mat-form-field class="padding-bottom">
        <mat-label>Ihr Aktivierungscode</mat-label>
        <input matInput formControlName="activationCode">
        <mat-error *ngIf="ctrlEmail.hasError('required')">
          Kein Aktivierungscode eingegeben
        </mat-error>
      </mat-form-field>
      <div>
        <button mat-button matStepperNext mat-raised-button [disabled]="!fgActivationCode.valid && !prefilledActivationKey">Weiter</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="fgEmail" label="E-Mail-Adresse prüfen" [editable]="!loading && !finished" [completed]="prefilledEmail || fgEmail.valid">
    <p>Geben Sie hier Ihre E-Mail-Adresse ein, mit welcher Sie sich im Mieterportal anmelden möchten.</p>
    <form [formGroup]="fgEmail">
      <mat-form-field class="padding-bottom">
        <mat-label>Ihre E-Mail-Adresse</mat-label>
        <input matInput formControlName="email">
        <mat-error *ngIf="ctrlEmail.hasError('required')">
          Keine E-Mail-Adresse eingegeben
        </mat-error>
        <mat-error *ngIf="ctrlEmail.hasError('email')">
          E-Mail-Adresse ist nicht gültig
        </mat-error>
      </mat-form-field>
      <div>
        <button mat-button mat-raised-button [disabled]="!fgEmail.valid && !prefilledEmail" (click)="emailCompleted()">Weiter</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="fgPassword" label="Passwort festlegen" [editable]="!loading && !finished">
    <form [formGroup]="fgPassword" *ngIf="passwordForExistingBenutzer">
      <p>Zu Ihrer E-Mail-Adresse besteht bereits ein Zugang. Bitte geben Sie Ihr Passwort ein. Die Wohnung wird dann Ihrem bestehenden Zugang zugeordnet.</p>
      <mat-form-field class="padding-bottom">
        <mat-label>Passwort</mat-label>
        <input matInput formControlName="password1" type="password" (change)="changePassword1()">
      </mat-form-field>
      <div>
        <button mat-button matStepperNext mat-raised-button [disabled]="!fgPassword.valid">Weiter</button>
      </div>
    </form>
    <form [formGroup]="fgPassword" *ngIf="!passwordForExistingBenutzer">
      <p>Das neue Passwort muss mindestens 8 Zeichen lang sein und aus mindestens einem Großbuchstaben, einem Kleinbuchstaben, einer Ziffer und einem Sonderzeichen (z.B. *, !, +, #, ?, %) bestehen.</p>
      <mat-form-field class="padding-bottom">
        <mat-label>Passwort</mat-label>
        <input matInput formControlName="password1" type="password" (change)="changePassword1()">
        <mat-error *ngIf="ctrlPassword1.errors">
          {{ctrlPassword1.errors.message}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="padding-bottom">
        <mat-label>Passwort wiederholen</mat-label>
        <input matInput formControlName="password2" type="password">
        <mat-error *ngIf="ctrlPassword2.errors">
          {{ctrlPassword2.errors.message}}
        </mat-error>
      </mat-form-field>
      <div>
        <button mat-button matStepperNext mat-raised-button [disabled]="!fgPassword.valid">Weiter</button>
      </div>
    </form>
  </mat-step>
  <mat-step [editable]="!loading && !finished">
    <ng-template matStepLabel>Konto aktivieren</ng-template>
    <p>
      Prüfen Sie noch einmal Ihre Daten und klicken Sie auf "Konto jetzt aktivieren".
    </p>
    <p>
      Aktivierungscode: <strong>{{ctrlActivationCode.value}}</strong><br>
      E-Mail-Adresse: <strong>{{ctrlEmail.value}}</strong>
    </p>
    <div>
      <button mat-raised-button [disabled]="loading" (click)="activateAccount()">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <mat-icon [class.hidden]="loading">how_to_reg</mat-icon>
        Konto jetzt aktivieren
      </button>
    </div>
    <div class="errors" *ngIf="errFailure || errWeak || errInvalidKey || errNotEqual">
      <div *ngIf="errFailure">
        <mat-icon>close</mat-icon>
        Es ist ein Fehler aufgetreten.
      </div>
      <div *ngIf="errWeak">
        <mat-icon>close</mat-icon>
        Das Passwort erfüllt nicht die Anforderungen.
      </div>
      <div *ngIf="errInvalidKey">
        <mat-icon>close</mat-icon>
        Der Aktivierungscode ist ungültig oder wurde bereits verwendet.
      </div>
      <div *ngIf="errNotEqual">
        <mat-icon>perm_identity</mat-icon>
        Die Passwörter stimmen nicht überein.
      </div>
    </div>
  </mat-step>
  <mat-step [editable]="!loading">
    <ng-template matStepLabel>Fertig</ng-template>
    <p>Ihr Konto wurde erfolgreich aktiviert. Sie können sich nun einloggen, um Ihre Verbrauchsdaten einzusehen.</p>
    <div>
      <button mat-button mat-raised-button (click)="goToLogin()">Zum Login</button>
    </div>
  </mat-step>
</mat-vertical-stepper>
